import { Box, Modal, Radio, RadioGroup, FormControlLabel } from '@mui/material'
import React, { useEffect, useState } from 'react'
import RadioButtonChecked from '../assets/imgs/radio-button-round-checked.svg'
import { getAllData } from '../apis/generalApis'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const SortByFilterModal = ({
  sortByFilterModal = false,
  handleSortByFilterModal,
  selectedSortDropdownOption,
  setSortByOption,
  setSelectedSortDropdownOption,
}) => {
  const sortByDropdownOptions = [
    {
      label: 'A --> Z',
      value: 'a_to_z',
      id: 1,
    },
    {
      label: 'Z --> A',
      value: 'z_to_a',
      id: 2,
    },
    {
      label: 'High --> Low',
      value: 'hi_to_lo',
      id: 3,
    },
    {
      label: 'Low --> High',
      value: 'lo_to_hi',
      id: 4,
    },
  ]
  return (
    <div>
      <Modal
        open={sortByFilterModal}
        onClose={() => handleSortByFilterModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="set-skill-rate-modal">
          <div className="text-center">
            <h5 className="color-primary">Sort By</h5>
            <hr />
            <div>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="five-star"
                name="radio-buttons-group"
              >
                {sortByDropdownOptions?.map((item, index) => (
                  <FormControlLabel
                    value={item.value}
                    key={item.id}
                    control={
                      <Radio
                        icon={
                          // <img
                          //   src={RadioButtonUnchecked}
                          //   height={20}
                          //   alt=""
                          //   className="p-0"
                          // />
                          <div className="unchecked-radio-div"></div>
                        }
                        checkedIcon={
                          <img
                            src={RadioButtonChecked}
                            height={20}
                            alt=""
                            className="p-0"
                          />
                          // <div className="unchecked-radio-div">
                          //   <div className="checked-radio-div"></div>
                          // </div>
                        }
                      />
                    }
                    className="align-items-center flex-wrap m-0 sub-service-option"
                    style={
                      selectedSortDropdownOption?.id === item.id
                        ? {
                            background:
                              'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 51%, #2992FB 100%) 0% 0% no-repeat padding-box',
                            borderRadius: '16px',
                          }
                        : {}
                    }
                    label={
                      <p
                        className={`fs-18 fw-bold sub-service-option-title ${
                          selectedSortDropdownOption?.id === item.id
                            ? 'text-black'
                            : 'color-primary'
                        }`}
                      >
                        {item.label}
                      </p>
                    }
                    checked={selectedSortDropdownOption?.id === item.id}
                    onClick={(e) => {
                      setSelectedSortDropdownOption(item)
                      handleSortByFilterModal()
                    }}
                  />
                ))}
              </RadioGroup>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  )
}
export default SortByFilterModal
